export const NOTIFICATION_DEFAULT_DURATION = 5000;
export const NOTIFICATION_EXIT_ANIMATION_DURATION = 230;
